import React, { Component } from "react";
import "./ValueField.css";

class ValueField extends Component {

  render() {
    return (
      <tr className="ValueField field">
        <th>{this.props.label}</th>
        <td>{this.props.value}</td>
      </tr>
    )
  }

}

export default ValueField;